import styled from 'styled-components';
import { PrePreOrderCheckoutTransitionOverlayStyled } from '../PrePreOrderCheckoutTransitionOverlayStyled';

export const PrePreOrderCheckoutTransitionOverlayStyledOV = styled(PrePreOrderCheckoutTransitionOverlayStyled)`
    background-color: #f1f1f1;
    .container > .actionSection > .wrapper {
        a,
        button {
            color: ${({ theme }) => theme.colors.black};
            font-weight: bold;

            &.call {
                color: ${({ theme }) => theme.colors.black};
                border-color: ${({ theme }) => theme.colors.primary};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.black};
                    }
                }

                &:hover {
                    background: ${({ theme }) => theme.colors.primary};
                    color: ${({ theme }) => theme.colors.black};

                    svg path {
                        fill: ${({ theme }) => theme.colors.black};
                    }
                }
            }

            &:hover {
                border-color: ${({ theme }) => theme.colors.primary};
                color: ${({ theme }) => theme.colors.black};
            }
        }
    }
`;
